<template>
  <div
    class="view-wrapper landing-wrapper"
    :style="{ 'background-image': 'url(' + bg + ')' }"
  >
    <Navbar />
    <div class="landing-content">
      <h6>Webinar Girişi</h6>
      <h2 class="event-title">{{ $root.event.title }}</h2>
      <div class="content-container card">
        <div class="card-body">
          <form class="card-text" @submit="handleTCID()">
            <p class="alert alert-danger" style="margin-bottom: 64px">
              Takeda tarafından düzenlenen/desteklenen bu web tabanlı toplantıya
              kendi bilgisayarınızdan bağlanmanız, iki veya daha fazla kişi bir
              araya gelerek katılmamanız hijyen ve sağlık açısından büyük önem
              arz etmektedir.
            </p>
            <div class="form-group">
              <label for="tckimlikno">TC Kimlik Numaranızı giriniz</label>
              <input
                id="tckimlikno"
                class="form-control form-control-lg"
                type="text"
                placeholder="TC Kimlik No"
                v-model="tcId"
                required
              />
            </div>
            <div class="form-group">
              <label for="name">Ad Soyad</label>
              <input
                id="name"
                class="form-control form-control-lg"
                type="text"
                placeholder="Ad Soyad"
                v-model="name"
                required
              />
            </div>
            <div class="form-group">
              <label for="email">Email</label>
              <input
                id="email"
                class="form-control form-control-lg"
                type="email"
                placeholder="Email"
                v-model="email"
                required
              />
            </div>
            <div class="form-group">
              <label for="eventpwd">Etkinlik Şifresi</label>
              <input
                id="eventpwd"
                class="form-control form-control-lg"
                type="password"
                placeholder="Etkinlik Şifresi"
                v-model="eventpwd"
              />
            </div>
            <p>
              Şirketimiz Takeda İlaç Sağlık San. Ticaret Limited Şirketi
              (“Takeda”) tarafından sağlanan web tabanlı toplantı hizmeti
              kapsamında; 03 Temmuz 2015 tarihli Resmi Gazetede yayınlanan
              “Beşeri Tıbbi Ürünlerin Tanıtım Faaliyetleri Hakkında Yönetmelik”
              (zaman zaman yapılabilecek ilgili tüm değişiklikleriyle birlikte
              geçerli olmak üzere, “Yönetmelik” olarak anılacaktır)
              çerçevesinde:
            </p>
            <div class="form-check">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customCheck1"
                  v-model="kvkk1"
                />
                <label class="custom-control-label" for="customCheck1">
                  <p>
                    Yukarıda ve bundan sonraki ekranlarda beyan ettiğim şahsi
                    bilgilerim ile ilgili, Türkiye İlaç ve Tıbbi Cihaz Kurumu
                    (“TİTCK”)’nun veri tabanında başvuru, giriş ve bildirim
                    işlemlerin yapılmasına ve bu platforma paylaşılmasına; ve bu
                    kapsamda sağladığım tüm kişisel verilerimin kaydedilmesine,
                    işlenmesine, gerekli olduğu hallerde üçüncü kişilere
                    transfer edilmesine 5 yıl süre ile saklanılmasına; açık rıza
                    verdiğimi kabul ve beyan ederim.
                  </p>
                </label>
              </div>
            </div>

            <div class="form-check">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customCheck2"
                  v-model="kvkk2"
                />
                <label class="custom-control-label" for="customCheck2">
                  <a
                    href="https://www.takeda.com/tr-tr/kullanm-koullar/"
                    target="_blank"
                    >Kişisel Verilerin Korunmasına İlişkin Aydınlatma ve Rıza
                    Metni’ni</a
                  >
                  okudum, onaylıyorum.
                </label>
              </div>
            </div>
            <button
              type="submit"
              class="btn btn-success btn-lg float-right"
              style="min-width: 120px"
            >
              Giriş
            </button>
          </form>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="tcIdModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">KVKK Onay</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            {{ error }}
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Kapat
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import "bootstrap/js/dist/modal";
export default {
  data() {
    return {
      pageSettings: null,
      tcId: null,
      name: null,
      email: null,
      eventpwd: null,
      kvkk1: false,
      kvkk2: false,
      bg: null,
      error: null
    };
  },
  name: "Landing",
  computed: {},
  methods: {
    handleTCID() {
      event.preventDefault();
      let nameArray = this.name.split(" ");
      let lastName = nameArray[nameArray.length - 1];
      let name = this.name.replace(lastName, "").trim();
      if (name == "") {
        this.error = "Lütfen adınızı ve soyadınızı tam olarak giriniz.";
        $("#tcIdModal").modal("show");
      } else if (!this.tcId || !this.kvkk1 || !this.kvkk2) {
        this.error =
          "Giriş için lütfen TC kimlik numaranızı girin ve iletişim onaylarını işaretleyin.";
        $("#tcIdModal").modal("show");
      } else {
        this.$axios
          .post("/postRegister", {
            tcId: this.tcId,
            name: name,
            lastName: lastName,
            email: this.email,
            eventPassword: this.eventpwd,
            eventId: this.$root.event.id
          })
          .then(res => {
            console.log(res);
            if (res.data.eventUrl) {
              window.location.href = res.data.eventUrl;
            } else {
              this.$root.regId = res.data.regId;
              this.$router.push({ name: "live" });
            }
          })
          .catch(error => {
            if (error.response.data) {
              let status = error.response.data.status;

              if (status == "smmrequired") {
                this.$router.push({ name: "smmrequired" });
              }
            }
          });
      }
      console.log(this.kvkk1, this.kvkk2);
    }
  },
  created() {
    this.bg =
      process.env.VUE_APP_API_SERVER + this.$root.event.backgroundImage.url;
  },
  components: {
    Navbar
  }
};
</script>
<style lang="scss">
.landing-wrapper {
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;
  background-position-y: top;
  background-attachment: fixed;
  height: 100vh;
  overflow: scroll;
  .bg-layer {
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.6);
  }
}

.landing-content {
  padding-top: 56px;
  width: 100%;
  max-width: 720px;
  position: relative;
  margin: auto;
  .content-container {
  }
}
.form-check {
  margin-bottom: 15px;
}
.card {
  border: none;
}
</style>
